import {PageDTO} from './page.model';
import {SectionDTO} from './section.model';
import {SubSectionDTO} from './sub-section.model';

export class UserDetailModel {
  public  username: string;
  public  password: string;
  public  statusCode: string;
  public  userroleCode: string;
  public  userRoleCategoryCode: string;
  public  employeeFirstName: string;
  public  applicationNo: string;
  public  employeeId: number;
  public pages: PageDTO[];
  public newPassword: string;
  public confirmPassword: string;
  public sectionCode: SectionDTO;
  public subsectionCode: SubSectionDTO;


  constructor(username: string, password: string, statusCode: string, userroleCode: string, userRoleCategoryCode: string, employeeFirstName: string, applicationNo: string, employeeId: number ,pages: PageDTO[],newPassword: string,confirmPassword: string, sectionCode: SectionDTO,subsectionCode: SubSectionDTO) {
    this.username = username;
    this.password = password;
    this.statusCode = statusCode;
    this.userroleCode = userroleCode;
    this.userRoleCategoryCode = userRoleCategoryCode;
    this.employeeFirstName = employeeFirstName;
    this.applicationNo = applicationNo;
    this.employeeId = employeeId;
    this.pages = pages;
    this.newPassword = newPassword;
    this.confirmPassword = confirmPassword;
    this.sectionCode = sectionCode;
    this.subsectionCode = subsectionCode;
  }

}
